export default {
	namespaced:true,
	actions:{
        
	},
	mutations:{
        
	},
	state:{
		title:[
			'第1节  光栅锐度能力测试',
			'第2节  截止频率能力测试',
			'第3节  游标锐度能力测试',
			'第4节  纹理感知能力测试',
			'第5节  纹理运动辨别能力测试',
			'第6节  光栅运动辨别能力测试',
			'第7节  噪音排除能力测试',
		],
		img:[
			['guangshanruiduLeft.png','guangshanruiduRight.png'],
			['jiezhipinlvLeft.png','jiezhipinlvRight.png'],
			['youbiaoruiduLeft.png','youbiaoruiduRight.png'],
			['wenliganzhiLeft.gif','wenliganzhiRight.gif'],
			['wenliyundongLeft.gif','wenliyundongRight.gif'],
			['guangshanyundongLeft.gif','guangshanyundongRight.gif'],
			['zaoyinpaichuLeft.png','zaoyinpaichuRight.png'],
		],
		btnLeftImg:[
			'heng.png',
			'heng.png',
			'pianzuo.png',
			'heng.png',
			'zuo.png',
			'zuo.png',
			'heng.png',
		],
		btnRightImg:[
			'shu.png',
			'shu.png',
			'pianyou.png',
			'shu.png',
			'you.png',
			'you.png',
			'shu.png',
		],
		btnLeftSpan:[
			'横',
			'横',
			'偏左',
			'横',
			'左',
			'左',
			'横',
		],
		btnRightSpan:[
			'竖',
			'竖',
			'偏右',
			'竖',
			'右',
			'右',
			'竖',
		],
		description:[
			['在本项测试中，屏幕中央位置会先闪烁红色方框，之后会出现如上所示的横向或竖向的光栅条纹，条纹出现后会立即消失，请注意观察。','条纹消失后，请点击下方按钮判断条纹的朝向','横','竖'],
			['在本项测试中，屏幕中央位置会先闪烁红色方框，之后会出现如上所示的横向或竖向的光栅条纹，条纹出现后会立即消失，请注意观察。','条纹消失后，请点击下方按钮判断条纹的朝向','横','竖'],
			['在本项测试中，屏幕中央位置会先闪烁红色方框，之后会出现如上所示的上下两条错位的条纹，条纹出现后会立即消失，请注意观察。','条纹消失后，请点击下方按钮判断上侧条纹相较于下侧条纹的偏移方向','偏左','偏右'],
			['在本项测试中，屏幕中央位置会先闪烁红色方框，之后会出现如上所示的抖动的横向或竖向的光栅条纹，条纹出现后会立即消失，请注意观察。','条纹消失后，请点击下方按钮判断条纹的朝向','横','竖'],
			['在本项测试中，屏幕中央位置会先闪烁红色方框，之后会出现如上所示的横向滚动的竖向条纹，条纹滚动一段时间后消失，请注意观察。','条纹消失后，请点击下方按钮判断条纹的滚动方向','左','右'],
			['在本项测试中，屏幕中央位置会先闪烁红色方框，之后会出现如上所示的横向滚动的竖向条纹，条纹滚动一段时间后消失，请注意观察。','条纹消失后，请点击下方按钮判断条纹的滚动方向','左','右'],
			['在本项测试中，屏幕中央位置会先闪烁红色方框，之后会出现如上所示的带干扰噪点的横向或竖向的光栅条纹，条纹出现后会立即消失，请注意观察。','条纹消失后，请点击下方按钮判断条纹的朝向','横','竖']
		]
	},
	getters:{
        
	},
}